import { render, staticRenderFns } from "./assignmenthistory.vue?vue&type=template&id=1830ec68&"
import script from "./assignmenthistory.vue?vue&type=script&lang=js&"
export * from "./assignmenthistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports